/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeApplyJobParams } from './workingModeApplyJobParams';

/**
 * Request model for working-mode apply essay job.
 */
export interface RunWorkingModeApplyJobRequest {
  type: 'working_mode_apply';
  params: WorkingModeApplyJobParams;
  allowOverlappingJobs?: boolean;
}
